import { render, staticRenderFns } from "./JSelectPublic.vue?vue&type=template&id=6f9fd573&scoped=true&"
import script from "./JSelectPublic.vue?vue&type=script&lang=js&"
export * from "./JSelectPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9fd573",
  null
  
)

export default component.exports